import { IconReceipt2, IconTruckDelivery, IconMapPin } from "@tabler/icons-react";
import type { PartnerDto } from "../../api";
import { PartnerAddressCard } from "./partner-address-card";

interface OrderAddressSectionProps {
  invoicePartner?: PartnerDto | null;
  shippingPartner?: PartnerDto | null;
  destAddress?: PartnerDto | null;
}

export function OrderAddressSection({
  invoicePartner,
  shippingPartner,
  destAddress,
}: OrderAddressSectionProps) {
  if (!invoicePartner && !shippingPartner && !destAddress) return null;

  return (
    <div className="flex flex-row flex-wrap gap-6 w-full">
      {invoicePartner && (
        <PartnerAddressCard
          title="Billing Address"
          icon={<IconReceipt2 size={18} />}
          partner={invoicePartner}
        />
      )}
      {shippingPartner && (
        <PartnerAddressCard
          title="Shipping Address"
          icon={<IconTruckDelivery size={18} />}
          partner={shippingPartner}
        />
      )}
      {destAddress && (
        <PartnerAddressCard
          title="Delivery Address"
          icon={<IconMapPin size={18} />}
          partner={destAddress}
        />
      )}
    </div>
  );
}
